// extracted by mini-css-extract-plugin
export default {"placeholderDateText":"TransactionHistoryContent_placeholderDateText__sM04H","pageDevider":"TransactionHistoryContent_pageDevider__tTSdn"};